import { Scanner, IDetectedBarcode, boundingBox } from '@yudiel/react-qr-scanner';
import React from 'react';

import clsx from 'clsx';
import { makeStyles, createStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            '& svg path': {
                stroke: theme.palette.primary.main,
            },
        },
        container: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            pointerEvents: 'none',
        },
        darkness: { position: 'absolute', backgroundColor: 'rgba(0, 0, 0, 0.3)' },
        topDarkness: { top: 0, left: 0, width: '100%', height: '30%' },
        rightDarkness: { top: '30%', right: 0, width: '15%', height: '40%' },
        leftDarkness: {
            top: '30%',
            left: 0,
            width: '15%',
            height: '40%',
        },
        bottomDarkness: { bottom: 0, left: 0, width: '100%', height: '30%' },
        finder: {
            position: 'absolute',
            top: '30%',
            left: '15%',
            width: '70%', // Ширина рамки
            height: '40%', // Висота рамки
            pointerEvents: 'none',
        },
        finderCorner: {
            position: 'absolute',
            width: '50px',
            height: '50px',
        },
        finderRightBottomCorner: {
            bottom: 0,
            right: 0,
            borderBottom: `5px solid ${theme.palette.primary.main}`,
            borderRight: `5px solid ${theme.palette.primary.main}`,
        },
        finderLeftBottomCorner: {
            bottom: 0,
            left: 0,
            borderBottom: `5px solid ${theme.palette.primary.main}`,
            borderLeft: `5px solid ${theme.palette.primary.main}`,
        },
        finderRightTopCorner: {
            top: 0,
            right: 0,
            borderTop: `5px solid ${theme.palette.primary.main}`,
            borderRight: `5px solid ${theme.palette.primary.main}`,
        },
        finderLeftTopCorner: {
            top: 0,
            left: 0,
            borderTop: `5px solid ${theme.palette.primary.main}`,
            borderLeft: `5px solid ${theme.palette.primary.main}`,
        },
    })
);

export interface CodeScannerProps {
    onScan: (code: string) => void;
}

export default function CodeScanner(props: CodeScannerProps) {
    const classes = useStyles();
    function getTracker() {
        return boundingBox;
    }

    function handleScan(detectedCodes: IDetectedBarcode[]) {
        if (detectedCodes.length > 0) {
            const code = detectedCodes[0];
            props.onScan(code.rawValue);
        }
    }
    return (
        <div
            style={{
                position: 'relative',
            }}
        >
            <Scanner
                classNames={{ container: classes.root }}
                onScan={(result) => handleScan(result)}
                formats={[
                    //'aztec',
                    'code_128',
                    'code_39',
                    'code_93',
                    'codabar',
                    'databar',
                    'databar_expanded',
                    'databar_limited',
                    //'data_matrix',
                    'dx_film_edge',
                    'ean_13',
                    'ean_8',
                    'itf',
                    //'maxi_code',
                    //'micro_qr_code',
                    //'pdf417',
                    //'qr_code',
                    //'rm_qr_code',
                    'upc_a',
                    'upc_e',
                    'linear_codes',
                    //'matrix_codes',
                    'any',
                    'unknown',
                ]}
                components={{
                    audio: true,
                    //onOff: true,
                    torch: true,
                    zoom: true,
                    finder: false,
                    tracker: getTracker(),
                }}
                styles={{
                    container: { width: '100%', height: '500px' },
                    video: { objectFit: 'cover' },
                }}
            />{' '}
            <div className={classes.container}>
                <div
                    className={clsx(classes.darkness, {
                        [classes.topDarkness]: true,
                    })}
                ></div>
                <div
                    className={clsx(classes.darkness, {
                        [classes.leftDarkness]: true,
                    })}
                ></div>
                <div
                    className={clsx(classes.darkness, {
                        [classes.rightDarkness]: true,
                    })}
                ></div>
                <div
                    className={clsx(classes.darkness, {
                        [classes.bottomDarkness]: true,
                    })}
                ></div>
            </div>
            <div className={classes.finder}>
                <div
                    className={clsx(classes.finderCorner, {
                        [classes.finderLeftTopCorner]: true,
                    })}
                ></div>
                <div
                    className={clsx(classes.finderCorner, {
                        [classes.finderRightTopCorner]: true,
                    })}
                ></div>
                <div
                    className={clsx(classes.finderCorner, {
                        [classes.finderLeftBottomCorner]: true,
                    })}
                ></div>
                <div
                    className={clsx(classes.finderCorner, {
                        [classes.finderRightBottomCorner]: true,
                    })}
                ></div>
            </div>
        </div>
    );
}
